import { InjectionToken } from '@angular/core';

import { AbstractVvcControlDirective } from '@vvc/components';
import { NzSafeAny } from 'ng-zorro-antd/core/types';

export const VVC_CONTROL_ACCESSOR = new InjectionToken<AbstractVvcControlDirective<NzSafeAny>>('NgControlAccessor');
